/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as queryString from 'query-string';

export function buildQuery(parameters: any): any {
  const queryParameters: any = {};
  let query = '';

  Object.keys(parameters).forEach((key) => {
    if (parameters[key] !== '') {
      queryParameters[key] = parameters[key];
    }
  });

  if (Object.keys(queryParameters).length !== 0) {
    query = '?' + queryString.stringify(queryParameters);
  }
  return query;
}

export function getQueryParam(key: string, defaultValue: any): any {
  let value: any = defaultValue;
  const inputQuery = queryString.parse(window.location.search, { arrayFormat: 'comma' });

  if (Object.entries(inputQuery).length !== 0 && Object.keys(inputQuery).includes(key) && inputQuery[key] != null) {
    value = inputQuery[key];
  }

  return value;
}

export function getQueryArrayParam(key: string, defaultValue: number[]): number[] {
  let value: number[] = defaultValue;
  value = parseArrayParams(key, value);
  return value;
}

export function getStringQueryArrayParam(key: string, defaultValue: string[]): string[] {
  let value: string[] = defaultValue;
  value = parseArrayParams(key, value);
  return value;
}

function parseArrayParams(key: string, value: any) {
  const inputQuery: any = queryString.parse(window.location.search, { arrayFormat: 'comma' });

  if (Object.entries(inputQuery).length !== 0 && Object.keys(inputQuery).includes(key) && inputQuery[key] != null) {
    value = value.concat(inputQuery[key]);
  }
  return value;
}

export function updateURLQuery(key: string, value: any): void {
  const inputQuery = queryString.parse(window.location.search, { arrayFormat: 'comma' });
  inputQuery[key] = value;
  const outputQuery = queryString.stringify(inputQuery, { arrayFormat: 'comma' });
  window.history.pushState(null, '', window.location.pathname + `?${outputQuery}`);
}

export function parseLinkHeader(linkHeader: string) {
  const linkHeadersArray = linkHeader.split(', ').map((header) => header.split(';'));
  const linkHeadersMap = linkHeadersArray.map((header) => {
    const thisHeaderRel = header[1].replace(/"/g, '').replace('rel=', '');
    const thisHeaderUrl = header[0].slice(1, -1);
    return [thisHeaderRel, thisHeaderUrl];
  });
  return Object.fromEntries(linkHeadersMap);
}
